/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global FormValidation, restCollection, autocompleete, snackbar, lng, RestEdit */

/**
 *
 * @param {Rest} rest
 * @returns {unresolved}
 */
function RestEditBasic(rest) {
  if (!this instanceof RestEditBasic) return RestEditBasic(rest);

  var that = this;

  // -- attributes --
  this.schema = rest.schema.schemaData;

  this.node = document.createElement("form");
  this._subject = null;

  this.onclose = function () {
    console.warn("onclose() Overwrite this!");
  };
  this.onchange = function () {
    console.warn("onchange() Overwrite this!");
  };

  // -- functions --
  this.loadSubject = loadSubject;

  // -- init --

  //create edit form for basic attributes
  that.node.autocomplete = "off";
  that.node.classList.add("basic");
  that.node.classList.add("mdl-card");
  that.node.classList.add("mdl-tabs__panel");
  that.node.classList.add("is-active");
  that.node.id = "general-information"; // set an id for tabs

  // var title = document.createElement('h4');
  // title.textContent = lng.get('general-information');
  // that.node.appendChild(title);

  var basicTable = document.createElement("table");
  basicTable.classList.add("mdl-data-table");
  basicTable.classList.add("mdl-js-data-table");

  var tbody = document.createElement("tbody");
  basicTable.appendChild(tbody);

  for (let key in that.schema) {
    let schemaItem = that.schema[key];
    if (schemaItem.type === "collection") continue;
    if (schemaItem.type === "static") continue;

    if (schemaItem.hideInDetails === true) {
      continue;
    }

    var tr = document.createElement("tr");

    var labelTd = document.createElement("td");
    labelTd.classList.add("mdl-data-table__cell--non-numeric");
    var label = document.createElement("label");
    label.textContent = schemaItem.label || key;
    labelTd.appendChild(label);
    if (schemaItem.tooltip)
      labelTd.insertAdjacentHTML(
        "beforeend",
        `
            <div class="icon material-icons tooltip">info_outline<span class="tooltiptext"> ${schemaItem.tooltip}
</span></div>
            `
      );
    tr.appendChild(labelTd);

    var inputTd = document.createElement("td");
    tr.appendChild(inputTd);

    let input = RestEdit.genInput(schemaItem, key, inputTd, that.node);

    if (typeof schemaItem.customEdit === "function") {
      input.addEventListener("click", function (e) {
        input.disabled = true;
        var customEdit = schemaItem.customEdit(that._subject);
        customEdit.onclose = (data) => {
          input.disabled = false;
          switch (schemaItem.type) {
            case "json":
              input.data = data;
              break;
            default:
              input.value = data;
          }
          return saveButttonClick();
        };
        customEdit.oncancel = () => (input.disabled = false);
      });
    }

    tbody.appendChild(tr);
  }

  //buttons
  tbody.insertAdjacentHTML(
    "beforeend",
    `
            <tr>
                <td colspan="2">
                    <i class="material-icons done">done</i>
                    <button class="delete mdl-button mdl-js-button mdl-button--raised mdl-button--accent">Löschen</button>
                    <input type="submit" class="save mdl-button mdl-js-button mdl-button--raised mdl-button--colored" value="Speichern">
                </td>
            </tr>
        `
  );
  that.node.appendChild(basicTable);

  var doneIcon = tbody.querySelector("i.done");
  var saveButton = tbody.querySelector("input[type=submit]");
  var deleteButton = tbody.querySelector("button.delete");

  deleteButton.addEventListener("click", function (e) {
    e.preventDefault();
    if (!that._subject || !that._subject.data.id) {
      return;
    }
    that._subject
      .destroy()
      .then((updatedSubject) => {
        if (!updatedSubject) return that.onclose();

        doneIcon.classList.add("visible");
        setTimeout(function () {
          doneIcon.classList.remove("visible");
        }, 1500);

        that.onchange();
        that.loadSubject(updatedSubject);
      })
      .catch((xhr) => {
        that.onchange();

        //deleted hard?
        if (xhr && xhr.status === 404) return that.onclose();

        snackbar.show({
          message: lng.get(xhr.status) || lng.get("unknownError"),
        });
      });
  });

  function saveButttonClick(e) {
    if (!that._subject || !that._subject.data.id)
      //NEW
      saveSubject(e, true);
    else saveSubject(e, false);
  }

  that.node.addEventListener("submit", (e) => saveButttonClick(e));

  function saveSubject(e, resave) {
    if (e) e.preventDefault();
    if (!that._subject || saveButton.disabled) return;

    saveButton.disabled = true;

    RestEditBasic.collectData(that._subject, that.schema, that.node);

    return that._subject
      .save()
      .then((updatedSubject) => {
        saveButton.disabled = false;
        doneIcon.classList.add("visible");
        setTimeout(function () {
          doneIcon.classList.remove("visible");
        }, 1500);

        if (!updatedSubject) return that.onclose();

        return updatedSubject.reload();
      })
      .then((updatedSubject) => {
        that.onchange();

        that.loadSubject(updatedSubject);

        //Save two times to set streetSchema and partnerImage
        if (resave && that.schema.streetSchema && that.schema.deliveryArea) {
          saveSubject(null, false);
        }
        return updatedSubject;
      })
      .catch((xhr) => {
        saveButton.disabled = false;

        //in case something else is gone wrong throw the error
        if (!(xhr instanceof XMLHttpRequest)) {
          throw xhr;
        }

        //validation error?
        if (xhr.status === 400) {
          var parsedErrors = rest.parseValidationError(
            JSON.parse(xhr.responseText)
          );

          if (parsedErrors) {
            for (var attribute in parsedErrors) {
              //get ul.error after the input
              var errorUl = that.node.querySelector(
                "input[name=" + attribute + "]"
              ).errorUl;
              if (!errorUl) {
                continue;
              }

              //remove old errors
              errorUl.innerHTML = null;

              var err = parsedErrors[attribute];

              //add an li for every error
              for (var j = 0, len2 = err.length; j < len2; j++) {
                var li = document.createElement("li");
                var errOriginalMsg = err[j];

                //try to map error message from lng
                var errMsg =
                  lng.get(`validation_${errOriginalMsg}`) || errOriginalMsg;

                //add some information from schema
                switch (errOriginalMsg) {
                  case "minLength":
                  case "maxLength":
                    errMsg += ` (${that.schema[attribute][errOriginalMsg]})`;
                    break;
                }

                li.textContent = errMsg;
                errorUl.appendChild(li);
              }

              //show errorUl
              errorUl.classList.add("visible");
            }

            //CUSTOM ERRORS!
            var errorLngValue;
            var errorMsg = xhr.responseText;
            if (errorMsg) {
              if (
                errorMsg.includes("A record with that `login` already exists")
              ) {
                errorLngValue = "unique";
              } else if (
                errorMsg.includes("A record with that `name` already exists")
              ) {
                errorLngValue = "unique";
              }
            }

            if (!errorLngValue) {
              console.log(errorMsg);
              errorLngValue = "custom";
            }

            var msg =
              lng.get(`${rest.schemaKey}_${errorLngValue}`) ||
              lng.get(xhr.status) ||
              lng.get("unknownError");
            snackbar.show({ message: msg });

            return;
          } //if error could not be parsed, continue
        }

        //an error message is probably provided for the http status code
        var msg =
          lng.get(`${rest.schemaKey}_${xhr.status}`) ||
          lng.get(xhr.status) ||
          lng.get("unknownError");
        snackbar.show({ message: msg });
      });
  }

  /**
   * @param {RestSubject} subject
   * @returns {undefined}
   */
  function loadSubject(subject) {
    that._subject = subject;

    const subjectData = that._subject.data;

    const selects = that.node.querySelectorAll("select");
    for (let i = 0, len = selects.length; i < len; i++) {
      const select = selects[i];
      if (!select.name) {
        continue;
      }

      if (select.type === "select") {
        select.selectedIndex = 0;
      }
    }
    //clear all inputs
    const inputs = that.node.querySelectorAll("input");
    for (let i = 0, len = inputs.length; i < len; i++) {
      const input = inputs[i];
      if (!input.name)
        //catch save button
        continue;

      switch (input.type) {
        case "text":
          input.value = null;
          //cause of model
          input.data = undefined;
          delete input.data;
          break;
        case "checkbox":
          input.checked = false;
          break;
        case "button":
          delete input.data;
          break;
        case "file":
          var imageThumb = input.parentNode.querySelector(".image-thumb");
          if (imageThumb) {
            imageThumb.src = "";
          }
          break;
        default:
          input.value = null;
      }
    }

    var textareas = that.node.querySelectorAll("textarea");
    for (var i = 0, len = textareas.length; i < len; i++) {
      var textarea = textareas[i];
      textarea.value = "";
    }

    function hasOwnProperty(obj, prop) {
      var proto = obj.__proto__ || obj.constructor.prototype;
      return prop in obj && (!(prop in proto) || proto[prop] !== obj[prop]);
    }

    for (const key in that.schema) {
      const schemaItem = that.schema[key];

      if (schemaItem.type === "area") {
        const textarea = that.node.querySelector("textarea[name=" + key + "]");
        let val = subjectData[key];

        if (textarea && val) textarea.value = val;
      } else if (schemaItem.type === "select") {
        const select = that.node.querySelector("select[name=" + key + "]");
        let val = subjectData[key];

        if (val) {
          let findIndex = schemaItem.options.findIndex(
            (element) => element.value === val
          );
          select.selectedIndex = findIndex;
        } else {
          select.selectedIndex = 0;
        }
      } else {
        let input = that.node.querySelector("input[name=" + key + "]");
        if (input === null) {
          //no found for collections
          continue;
        }

        let val = subjectData[key];
        switch (schemaItem.type) {
          case "text":
          case "number":
          case "email":
            input.value = val || null;
            break;
          case "datetime":
            console.warn("to string not implemented for datetime");
            input.value = val || null;
            break;
          case "date":
            if (val) {
              input.value = new Date(val).toISOString().split("T")[0]; //get yyyy-MM-dd
              input.type = "date";
              input.valueAsDate = new Date(val);
              input.valueAsNumber = new Date(val).getTime();
              delete input._flatpickr;
            }
            const fpLocale = {
              weekdays: {
                shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
                longhand: [
                  "Sonntag",
                  "Montag",
                  "Dienstag",
                  "Mittwoch",
                  "Donnerstag",
                  "Freitag",
                  "Samstag",
                ],
              },
              months: {
                shorthand: [
                  "Jan",
                  "Feb",
                  "Mär",
                  "Apr",
                  "Mai",
                  "Jun",
                  "Jul",
                  "Aug",
                  "Sep",
                  "Okt",
                  "Nov",
                  "Dez",
                ],
                longhand: [
                  "Januar",
                  "Februar",
                  "März",
                  "April",
                  "Mai",
                  "Juni",
                  "Juli",
                  "August",
                  "September",
                  "Oktober",
                  "November",
                  "Dezember",
                ],
              },
              firstDayOfWeek: 1,
              weekAbbreviation: "KW",
              rangeSeparator: " bis ",
              scrollTitle: "Zum Ändern scrollen",
              toggleTitle: "Zum Umschalten klicken",
            };
            new Flatpickr(input, {
              locale: fpLocale,
              dateFormat: "d.m.Y",
            });
            break;
          case "password":
            if (hasOwnProperty(schemaItem, "lastLogin")) input.value = val;
            else input.value = "";
            break;
          case "checkbox":
            input.checked = !!val;
            break;
          case "model":
            if (val) {
              if (!schemaItem.getData) {
                input.value = schemaItem.getString(subjectData) || null;
                input.data = val;
              } else {
                input.value = subjectData.partner || null;
                input.data = val;
              }
            }
            break;
          case "json":
            input.data = val;
            break;
          case "file":
            if (schemaItem.showThumbnail) {
              //we expect an image here
              const imageThumb = input.parentNode.querySelector(".image-thumb");
              if (val && imageThumb) {
                const schemakey = schemaItem.via || key;
                const fileSchema = restCollection[schemakey];

                imageThumb.src = fileSchema.endPoint + "/" + val.id;
              }
            } else if (schemaItem.label === "Straßenverzeichnis") {
              const csvLabel = input.parentNode.querySelector(".csv-name");
              if (val && csvLabel) {
                csvLabel.textContent = val.name;
              } else if (csvLabel) {
                csvLabel.textContent = "";
              }
            } else {
              var csvLabel = input.parentNode.querySelector(".csv-name");
              if (val && csvLabel) {
                csvLabel.textContent = val.name;
              }
            }
            break;
          case "select":
            break;
          case "button":
            break;
          default:
            console.error("type " + schemaItem.type + " not implemented");
        }

        var access = schemaItem.access;
        switch (typeof access) {
          case "undefined":
            break;
          case "function":
            input.disabled = !access(subjectData);
            break;
          default:
            //boolean, string, number, object
            input.disabled = !access;
        }

        //set required here only for new instances, cause of some write only fields
        input.required =
          subject.data.id || subject.id ? false : !!schemaItem.required;

        //error hints
        var errorUl = input.errorUl;
        if (errorUl && errorUl.classList.contains("error"))
          errorUl.classList.remove("visible");
      }
    }

    var parent = deleteButton.parentNode;

    //remove old behavior
    var oldBehavoir = Array.from(parent.querySelectorAll("ul.behavior"));
    oldBehavoir.map((e) => parent.removeChild(e));

    deleteButton.style.display = null;
    saveButton.style.display = null;

    if (!that._subject.id) return;

    //check behavior and append info to buttons
    that._subject
      .checkBehavior()
      .then((behavior) => {
        var destroyBehavior = behavior.destroy;
        var updateBehavior = behavior.update;

        destroyBehavior = genList(destroyBehavior);
        updateBehavior = genList(updateBehavior);

        if (destroyBehavior) {
          //insert after
          parent.appendChild(destroyBehavior);
        } else {
          deleteButton.style.display = "none";
        }

        if (updateBehavior) {
          //insert after
          parent.appendChild(updateBehavior);
        } else {
          saveButton.style.display = "none";
        }

        function genList(arr) {
          if (arr.length === 0) return null;

          var ul = document.createElement("ul");
          ul.classList.add("behavior");

          arr.map((b) => {
            var li = document.createElement("li");
            li.textContent = lng.get("behavior-" + b);
            ul.appendChild(li);
          });

          return ul;
        }
      })
      .catch(() => {
        //just ignore. Not all Models have this function
      });
  }
}

Object.defineProperty(RestEditBasic, "collectData", {
  enumerable: false,
  /**
   * Applies data from inputs inside the <i>wrapper</i>.
   * <i>save</i> will not be called here.
   * @param {RestSubject} subject
   * @param {object} schemaData
   * @param {Element} wrapper
   * @returns {undefined}
   */
  value: function (subject, schemaData, wrapper) {
    for (let key in schemaData) {
      const schemaItem = schemaData[key];
      if (schemaItem.type === "collection") continue;
      if (schemaItem.type === "static") continue;

      let input;

      if (schemaItem.type === "area")
        input = wrapper.querySelector("textarea[name=" + key + "]");
      else input = wrapper.querySelector("input[name=" + key + "]");

      if (!input) {
        const select = wrapper.querySelector("select[name=" + key + "]");
        if (!select) continue;

        let selectedOption = select.options[select.selectedIndex];

        if (selectedOption && selectedOption.value) {
          subject.data[select.name] = selectedOption.value;
        } else {
          subject.data[select.name] = "";
        }
      } else {
        let value = input.value;
        switch (schemaItem.type) {
          case "date":
            console.warn("TODO check date value on client side");
            break;
          case "checkbox": //use checked attribute
            value = input.checked;
            break;
          case "password": //do not use empty passwords
            if (value.length === 0) continue;
            break;
          case "model":
            if (schemaItem.label === "Verkaufsleiter") {
              if (input.value.length === 0) {
                value = "";
              } else if (input.data) value = input.data.id;
              else if (input.value) value = input.value.id;
            } else if (input.data) value = input.data.id;
            else if (input.value) value = input.value.id;
            break;
          case "json":
            try {
              if (!input.data) {
                return;
              }

              //use this as validator
              JSON.parse(input.data);
              value = input.data;
              //stringify it to have a string after subject parse
              //value = JSON.stringify(value);
            } catch (e) {
              snackbar.show({ message: lng.get("validation_json") });
              value = null;
            }
            break;
          case "file":
            var file = input.files[0];
            value = file ? file : null;
            break;
        }
        subject.data[input.name] = value;
      }
    }
  },
});
